export const FIRST_MONTH_INDEX = 0;
export const LAST_MONTH_INDEX = 11;

export enum CALENDAR_VIEWS {
  DAYS = "days",
  MONTHS = "months",
  YEARS = "years",
}

export enum CALENDAR_TYPES {
  SINGLE = "single",
  MULTIPLE = "multiple",
  RANGE = "range",
}
